<template>
  <div>
    <Header />
    <main>
      <section class="shop">
        <i class="fas fa-search"></i>
        <h1>Track</h1>
      </section>

      <section class="tracking-form">
        <input v-model="trackId" type="text" placeholder="Enter Track ID" />
        <button @click="searchOrder">Search</button>
      </section>

      <section v-if="order" class="order-info">
        <p><strong>Email:</strong> {{ order.email }}</p>
        <p><strong>Discord Name:</strong> {{ order.discordName }}</p>
        <p><strong>Coordinates:</strong> {{ order.coordinates }}</p>
        <p><strong>Stage:</strong> {{ order.stage }}</p>
        <p><strong>Price:</strong> ${{ order.price }}</p>
        <p><strong>Payment Method:</strong> {{ order.paymentMethod }}</p>
        <p><strong>Kits:</strong>
          {{
            Object.entries(
                order.kits.reduce((acc, name) => {
                  acc[name] = (acc[name] || 0) + 1;
                  return acc;
                }, {})
            )
                .map(([name, count]) => `${count}x ${name}`)
                .join(', ')
          }}
        </p>
        <p><strong>Order Date:</strong> {{ order.timestamp.toDate().toLocaleString() }}</p>
      </section>

      <section v-else-if="searched" class="order-info">
        <p>No order found with this Track ID.</p>
      </section>
    </main>
  </div>
</template>

<script>
import Header from '../Header/Header.vue'
import {doc, getDoc} from "firebase/firestore"
import {db} from "@/firebase";

export default {
  name: 'Track',
  components: {
    Header
  },
  data() {
    return {
      trackId: '',
      order: null,
      searched: false
    }
  },
  methods: {
    async searchOrder() {
      this.order = null;
      this.searched = false;

      const orderDoc = doc(db, 'payments', this.trackId);

      await getDoc(orderDoc).then(doc => {
        if(doc.exists) {
          this.order = doc.data();
        }
      });

      this.searched = true;
    }
  },
  metaInfo() {
    return {
      title: "Track | ShopT"
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem;
  color: #fff;
}

.tracking-form {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tracking-form input {
  padding: 0.8rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 2px solid #444;
  background-color: #222;
  color: #fff;
  width: 300px;
  margin-bottom: 1rem;
}

.tracking-form button {
  margin-top: 15px;
  width: 100%;
  padding: 10px;
  background-color: #4ec7f3;
  color: #111;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.tracking-form button:hover {
  background-color: #3ab0db;
}

.order-info {
  width: 100%;
  max-width: 800px;
  margin-top: 2rem;
  padding: 2rem;
  background-color: #222;
  border-radius: 10px;
  border: 2px solid #444;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.order-info p {
  font-size: 1.1rem;
  color: #ccc;
  margin-bottom: 1rem;
}

.shop {
  width: 100%;
  max-width: 400px;
  margin: 3rem 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>
